import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '@UI/New/Button'
import { selectProfile } from '@store/profile.reducer'
import useRoles from '@/hooks/useRoles'
import NotificationsSettings from './NotificationsSettings'

interface NotificationsSettingsButtonProps {
  userId?: number | null
}

const NotificationsSettingsButton = ({
  userId,
}: NotificationsSettingsButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const profile = useSelector(selectProfile) as IUser
  const roles = useRoles()
  const notificationSettingsAccess = useSelector((store: any) => ({
    teacher: store.settings?.isDisableNotificationSettingsForTeacher === '1',
    student: store.settings?.isDisableNotificationSettingsForStudent === '1',
    parent: store.settings?.isDisableNotificationSettingsForParent === '1',
  }))

  const isAvailable = useMemo(() => {
    if (roles.isAdminOrJuniorSeminarian && notificationSettingsAccess.teacher)
      return false
    if (roles.isChildren && notificationSettingsAccess.student) return false
    if (roles.isParent && notificationSettingsAccess.parent) return false

    return true
  }, [notificationSettingsAccess, roles])

  if (!isAvailable) return null

  const openSettings = () => setIsOpen(true)
  const closeSettings = () => setIsOpen(false)

  return (
    <>
      <Button color={'secondary'} onClick={openSettings}>
        Настройки уведомлений
      </Button>
      <NotificationsSettings
        open={isOpen}
        userId={userId ?? profile?.id}
        onDismiss={closeSettings}
      />
    </>
  )
}

export default NotificationsSettingsButton
